import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { updateTimestamps } from '../api/services/Rides';
import { TimestampsFormType } from '../types/timestamps';

interface iUseTimestampUpdates {
  rideSlug: string;
  successCallback?: () => void;
  errorCallback?: (
    error:
      | Error & {
          errors: string[];
        }
  ) => void;
}

export const useTimestampUpdates = ({ rideSlug, successCallback, errorCallback }: iUseTimestampUpdates) => {
  return useApiSend(
    (payload: TimestampsFormType) => updateTimestamps(rideSlug, payload),
    successCallback,
    errorCallback,
    ['rideDetails', 'rideOverview'],
    undefined
  );
};
